<div class="connect-wrapper" *ngIf="connectData">
    <div *ngIf="screenWidth > 1024" class="gallery fade-out-1" [ngClass]="{'fade-in-1': loadGallery}">
        <div class="gallery-item" *ngFor="let item of connectData.gallery; let i = index" [ngClass]="{'active': activeImage == i}">
            <img src="{{item.image}}" alt="" (load)="loadedImage()">
        </div>
    </div>
    <div *ngIf="screenWidth <= 1024" class="mobile-gallery fade-out-2" [ngClass]="{'fade-in-2': loadGallery}">
        <div class="gallery-item" *ngFor="let item of connectData.mobile_gallery; let i = index" [ngClass]="{'active': activeMobileImage == i}">
            <img src="{{item.image}}" alt="" (load)="loadedImage()">
        </div>
    </div>

    <div class="title fade-out-1" *ngIf="screenWidth <= 1024" [ngClass]="{'fade-in-1': loadTitle}">
        <h1>CONNECT</h1>
    </div>

    <div class="content">
        <h1 class="fade-out-1" [ngClass]="{'fade-in-1': loadContentTitle}">{{ connectData.content_title }}</h1>
        <h3 class="paragraph1 fade-out-1" [ngClass]="{'fade-in-1': loadContentParagraph}">{{ connectData.content_paragraph }}</h3>
        <div class="excerpt fade-out-1" [ngClass]="{'fade-in-1': loadContentExcerpt}" [innerHtml]="connectData.content_excerpt"></div>
    </div>

    <div class="links">
        <div class="emails">
            <div class="first-email">
                <p class="fade-out-1" [ngClass]="{'fade-in-1': loadEmailsTitle}" >{{connectData.first_email_title}}</p>
                <a class="link2 fade-out-1 d-block" [ngClass]="{'fade-in-1': loadEmails}" href="mailto:{{connectData.first_email}}" >{{connectData.first_email}}</a>
            </div>
            <div class="second-email">
                <p class="fade-out-1" [ngClass]="{'fade-in-1': loadEmailsTitle}" >{{connectData.second_email_title}}</p>
                <a class="link2 fade-out-1 d-block" [ngClass]="{'fade-in-1': loadEmails}" href="mailto:{{connectData.second_email}}" >{{connectData.second_email}}</a>
            </div>
        </div>

        <div class="socials">
            <li *ngFor="let social of socials; let i = index">
                <a target="{{social.target}}" class="link6 d-block fade-out-1" [ngClass]="{'fade-in-1': (i==0 && loadSocials1 || i==1 && loadSocials2 || i==2 && loadSocials3 || i==3 && loadSocials4 || i==4 && loadSocials5)}" href="{{social.url}}">{{social.title}}</a>
            </li>
        </div>
    </div>

    <div class="excerpt-mobile fade-out-1" [ngClass]="{'fade-in-1': loadContentExcerptMobile}" [innerHtml]="connectData.content_excerpt_mobile"></div>
</div>